import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import { useState } from "react";
import { StyledTableCell } from "../common/styles";
import CategoryInnerRow from "./categoryInnerRow";
import EmptyTableData from "../common/EmptyTableData";
import { ColorPallet } from "../../utils/colorPallet";
import { CategoryHeaderData } from "../../utils/constants";
import { CustomPagination } from "../commontable/customPagination";

interface IProps {
  catData: any;
  setReloadCategory: any;
  page?: number;
  rowsPerPage?: number;
  totalCount?: number;
  onPageChange?: any;
  onRowsPerPageChange?: any;
  isPagination?: any;
}

const CategoryTable = ({
  catData,
  setReloadCategory,
  page,
  rowsPerPage,
  totalCount,
  onPageChange,
  onRowsPerPageChange,
  isPagination,
}: IProps) => {
  const [openAddModal, setOpenAddModal] = useState(false);
  const [selectedExpense, setSelectedExpense] = useState(null);

  const handleOpenAddModal = (category?: any) => {
    setSelectedExpense(category || null);
    setOpenAddModal(true);
  };

  return (
    <>
      <Box sx={{ mt: 3 }}>
        <TableContainer sx={{ maxHeight: "55vh", overflow: "auto" }}>
          <Table
            stickyHeader // Optional helper prop
            sx={{
              border: "1px solid #D3D3D3",
              borderCollapse: "collapse", // <- CRUCIAL
            }}
          >
            <TableHead>
              <TableRow sx={{ height: "12px" }}>
                {CategoryHeaderData.map((header: any, index: number) => (
                  <StyledTableCell
                    key={index}
                    sx={{
                      position: "sticky",
                      top: 0,
                      zIndex: 2,
                      color: ColorPallet.primaryGrey,
                      fontSize: "16px",
                      fontWeight: 500,
                      border: "1px solid #D3D3D3",
                    }}
                  >
                    {header}
                  </StyledTableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {[...catData].reverse().map((category: any, index: number) => (
                <CategoryInnerRow
                  key={index}
                  category={category}
                  setReloadCategory={setReloadCategory}
                  handleOpenModal={() => handleOpenAddModal(category)}
                />
              ))}
            </TableBody>
          </Table>
          {catData?.length === 0 ? (
            <EmptyTableData height="45vh" message="No Data found!" />
          ) : null}
        </TableContainer>
      </Box>

      {isPagination ? null : (
        <CustomPagination
          totalCount={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
        />
      )}
    </>
  );
};

export default CategoryTable;
